import script from "./CardLightbox.vue?vue&type=script&setup=true&lang=js"
export * from "./CardLightbox.vue?vue&type=script&setup=true&lang=js"

import "./CardLightbox.vue?vue&type=style&index=0&id=27630d58&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27630d58"]])

export default __exports__